import { foundations } from '../foundations';
const { colors, shadows } = foundations;

export const Input = {
  baseStyle: ({ colorMode }: { colorMode: 'dark' | 'light' }) => ({
    field: {
      fontSize: '0.875rem',
      color: colors.text.base[colorMode],
      _disabled: {
        color: colors.text.secondary[colorMode],
      },
      _placeholder: {
        color: colors.text.secondary[colorMode],
      },
      '::-webkit-calendar-picker-indicator': {
        bg: 'rgba(0,0,0,0)',
        bottom: 0,
        color: 'rgba(0,0,0,0)',
        cursor: 'pointer',
        height: 'auto',
        left: 0,
        position: 'absolute',
        right: 0,
        top: 0,
        width: 'auto',
      },
      '::file-selector-button': {
        display: 'none',
      },
    },
    addon: {
      fontSize: '0.75rem',
      color: colors.text.secondary[colorMode],
    },
    element: {
      color: colors.icon.default,
    },
    sizes: {
      xs: {
        field: {
          fontSize: '0.75rem',
        },
      },
      lg: {
        addon: {
          textStyle: 'body',
        },
      },
    },
  }),

  variants: {
    outline: ({ colorMode }: { colorMode: 'dark' | 'light' }) => ({
      field: {
        borderRadius: '0.325rem',
        bg: colors.background.form.default[colorMode],
        border: `1px solid ${colors.border.form.default[colorMode]}`,
        _hover: {
          shadow: 'none',
          borderColor: colors.border.form.hover[colorMode],
        },
        _focus: {
          shadow: shadows.outline,
          borderColor: colors.border.form.focus,
        },
        _invalid: {
          shadow: 'none',
          borderColor: colors.border.form.critical[colorMode],
        },
        _disabled: {
          bg: colors.background.form.disabled[colorMode],
          color: colors.text.secondary[colorMode],
          border: `1px solid ${colors.border.form.default[colorMode]}`,
        },
      },
      addon: {
        bg: colors.background.form.disabled[colorMode],
        borderLeftColor: colors.border.form.default[colorMode],
        borderRadius: '0.325rem',
      },
    }),
  },
};
